import { BaguetteIcon } from './BaguetteIcon';

/**
 * author: Nick
 * id B6469241-E347-42D8-BF71-8DF29F1CA897
 * name baguette
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baguette.svg
 * tags
 * - Food / Drink 
 */
export const LoafIcon = BaguetteIcon;
export default LoafIcon